import { z } from 'zod'

import { InventoryType } from '../constants/inventory'
import { DiscountAudience, DiscountType } from '../constants/pricing'
import { dbEntitySchema } from './system'

export const platformDiscountSchema = dbEntitySchema.extend({
  name: z.string().optional(),
  expiration: z.date().optional(),
  inventory: z.array(z.string()).optional(),
  inventoryTypes: z.array(z.nativeEnum(InventoryType)).optional(),
  events: z.array(z.string()).optional(),
  membershipPlans: z.array(z.string()).optional(),
  type: z.nativeEnum(DiscountAudience),
  amount: z.number().min(0),
  amountType: z.nativeEnum(DiscountType),
  quantityAppliedMax: z.number().min(0),
})

export const platformDiscountCreateArgsSchema = z.object({
  name: z.string().optional(),
  expiration: z.date().optional(),
  inventory: z.array(z.string()).optional(),
  inventoryTypes: z.array(z.nativeEnum(InventoryType)).optional(),
  events: z.array(z.string()).optional(),
  membershipPlans: z.array(z.string()).optional(),
  type: z.nativeEnum(DiscountAudience),
  amount: z.number(),
  amountType: z.nativeEnum(DiscountType),
  quantityAppliedMax: z.number().optional(),
  inventoryType: z
    .union([z.nativeEnum(InventoryType), z.array(z.nativeEnum(InventoryType))])
    .optional(),
  membershipPlanId: z.union([z.string(), z.array(z.string())]).optional(),
})

export const platformDiscountUpdateByIdArgsSchema = z.object({
  type: z.nativeEnum(DiscountAudience).optional(),
  amount: z.number().optional(),
  amountType: z.nativeEnum(DiscountType).optional(),
  quantityAppliedMax: z.number().optional(),
  expiration: z.date().optional(),
  name: z.string().optional(),
  inventoryType: z
    .union([z.nativeEnum(InventoryType), z.array(z.nativeEnum(InventoryType))])
    .optional(),
  membershipPlanId: z.union([z.string(), z.array(z.string())]).optional(),
})

export const userDiscountSchema = dbEntitySchema.extend({
  user: z.string(),
  discount: z.string(),
  name: z.string().optional(),
  expiration: z.date().optional(),
  used: z.boolean(),
  promo: z.string().optional(),
  inventory: z.array(z.string()).optional(),
  inventoryTypes: z.array(z.nativeEnum(InventoryType)).optional(),
  events: z.array(z.string()).optional(),
  type: z.nativeEnum(DiscountAudience),
  amount: z.number().min(0),
  amountType: z.nativeEnum(DiscountType),
  // Legacy model supports negative values (-1) for unlimited application.
  quantityAppliedMax: z.number(),
})
